import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Redirect,
  Route,
} from "react-router-dom";
import { setConfiguration } from "react-grid-system";

import CopyProvider from "./CopyProvider.js";

import Home from "./Home/Home.js";
import Wizard from "./Wizard/Wizard.js";
import Legal from "./Legal/Legal.js";
import NotFound from "./NotFound.js";

import { Container } from "react-grid-system";

import {
  breakpoints,
  containerWidths,
  gutterWidth,
} from "./style/Variables.js";

class App extends Component {
  constructor(props) {
    super(props);
    //
    setConfiguration({
      breakpoints,
      containerWidths,
      gutterWidth,
      defaultScreenClass: "xs",
    });
  }
  render() {
    return (
      <Container className="outer-wrapper no-gutter" fluid>
        <Router>
          <ScopeForUpdatingCopy />
        </Router>
      </Container>
    );
  }
}

const locales = {
  en: "en.js",
  de: "de.js",
};
const ScopeForUpdatingCopy = () => {
  const locale = CopyProvider.getLocale();
  return (
    <CopyProvider locale={locale} locales={locales}>
      <Switch>
        <Redirect exact from="/" to={`/${locale}`} />
        <Redirect from="/wizard" to={`/${locale}/wizard`} />
        <Route exact path="/:locale" component={Home} />
        <Route exact path="/:locale/impressum" component={Legal} />
        <Route path="/:locale/wizard" component={Wizard} />
        <Route component={NotFound} />
      </Switch>
    </CopyProvider>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js